"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var const_1 = require("./const");
var prosemirror_tables_1 = require("prosemirror-tables");
var menu_helper_1 = require("./menu-helper");
var utils_1 = require("./utils");
var isInCellSelection = function (sel, pos) {
    return sel.ranges.some(function (_a) {
        var $from = _a.$from, $to = _a.$to;
        return pos >= $from.pos && pos <= $to.pos;
    });
};
var ContextMenuComponent = /** @class */ (function () {
    function ContextMenuComponent(options) {
        var _this = this;
        this.preventMouseDown = function (e) {
            if (e.button === 2) {
                var $dom = e.target && e.target.parentElement;
                while ($dom && _this.props.editorView.dom.contains($dom)) {
                    if ($dom.tagName === 'TABLE') {
                        e.preventDefault();
                        break;
                    }
                    $dom = $dom.parentElement;
                }
            }
        };
        this._contextmenu = function (e) {
            var editorView = _this.props.editorView;
            var _a = editorView.state, selection = _a.selection, doc = _a.doc, tr = _a.tr;
            var $dom = e.target && e.target.parentElement;
            if (!$dom || !editorView.dom.contains($dom))
                return _this.hide();
            var pos = editorView.posAtDOM($dom, 0);
            var $pos = doc.resolve(pos);
            var contextNode = $pos.node(1);
            // 不在表格内，不做处理
            if (!contextNode || contextNode.type.name !== const_1.NODE_NAME.TABLE)
                return _this.hide();
            // 如果不在cellSelection内右键，设置一个CellSelection
            if (!(selection instanceof prosemirror_tables_1.CellSelection) || !isInCellSelection(selection, pos)) {
                var selectedCell = utils_1.closestCell($pos);
                if (selectedCell) {
                    // @ts-ignore
                    tr.setSelection(prosemirror_tables_1.CellSelection.create(doc, selectedCell.from));
                    editorView.dispatch(tr);
                }
            }
            e.preventDefault();
            e.stopPropagation();
            _this.updateMenu();
            _this.show(e);
        };
        this.create = function () {
            _this.$container.classList.add('table-context-wrap');
            var child = _this._getMenus();
            if (_this.$container.children.length) {
                _this.$container.removeChild(_this.$container.children[0]);
            }
            _this.$container.appendChild(child);
        };
        this.hide = function () {
            var $menu = _this.$container;
            if ($menu && $menu.style) {
                $menu.style.display = 'none';
                if (_this.props.editor.command.toolbarInline)
                    _this.props.editor.command.toolbarInline.enable();
            }
        };
        this.$container = document.createElement('div');
        this.props = options;
        this.bindEvent();
    }
    ContextMenuComponent.prototype.updateProps = function (options) {
        this.props = __assign(__assign({}, this.props), options);
        this.create();
    };
    ContextMenuComponent.prototype.updateMenu = function () {
        this.updateProps({
            menus: menu_helper_1.formatMenu(this.props.editorView, const_1.createMenu(this.props.editor.configurator.getLocaleValue('table'))),
            editorView: this.props.editorView
        });
    };
    ContextMenuComponent.prototype.bindEvent = function () {
        this.props.editor.root.addEventListener('contextmenu', this._contextmenu, true);
        this.props.editor.root.addEventListener('mousedown', this.preventMouseDown, true);
    };
    ContextMenuComponent.prototype.unBindEvent = function () {
        this.props.editor.root.removeEventListener('contextmenu', this._contextmenu, true);
        this.props.editor.root.removeEventListener('mousedown', this.preventMouseDown, true);
    };
    ContextMenuComponent.prototype._getMenus = function () {
        var _this = this;
        var menus = this.props.menus;
        var $dom = document.createElement('ul');
        $dom.classList.add('table-context-menu');
        if (menus && menus.length) {
            var editorView_1 = this.props.editorView;
            menus.forEach(function (menu) {
                var child = document.createElement('li');
                if (typeof menu !== 'string') {
                    var name_1 = menu.name, callback_1 = menu.callback, disable = menu.disable, tip = menu.tip;
                    child.textContent = name_1;
                    if (disable) {
                        child.setAttribute('disable', '1');
                    }
                    if (tip) {
                        child.classList.add('syl-menu-cell', 'pop-tip-left');
                        var $span = document.createElement('span');
                        $span.innerHTML = tip;
                        child.appendChild($span);
                    }
                    child.onclick = function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        _this.hide();
                        callback_1(editorView_1);
                        editorView_1.focus();
                    };
                }
                else {
                    child = document.createElement('div');
                    child.classList.add('menu-split');
                }
                $dom.appendChild(child);
            });
        }
        return $dom;
    };
    ContextMenuComponent.prototype.show = function (e) {
        var $menu = this.$container;
        $menu.style.display = 'block';
        $menu.style.position = 'absolute';
        var editorDom = document.body;
        if (editorDom && !editorDom.contains(this.$container)) {
            editorDom.appendChild(this.$container);
        }
        var rect = {
            width: this.$container.clientWidth,
            height: this.$container.clientHeight
        };
        var cursorRect = {
            clientY: e.clientY,
            clientX: e.clientX
        };
        var _a = menu_helper_1.calculateMenuPosition(cursorRect, rect), top = _a.top, left = _a.left;
        $menu.style.top = top + "px";
        $menu.style.left = left + "px";
        if (this.props.editor.command.toolbarInline)
            this.props.editor.command.toolbarInline.disable();
    };
    return ContextMenuComponent;
}());
var TableContextMenu = /** @class */ (function () {
    function TableContextMenu(editor, editorView) {
        this.editor = editor;
        this.view = editorView;
        this.type = editorView.state.schema.nodes[const_1.NODE_NAME.TABLE];
        this.$contextMenuComponent = new ContextMenuComponent({
            editor: editor,
            editorView: editorView
        });
        this.view.dom.addEventListener('click', this.$contextMenuComponent.hide);
    }
    TableContextMenu.prototype.update = function (view, prevState) {
        if (!prosemirror_tables_1.isInTable(view.state))
            this.$contextMenuComponent.hide();
    };
    TableContextMenu.prototype.destroy = function () {
        this.$contextMenuComponent.unBindEvent();
        this.view.dom.removeEventListener('click', this.$contextMenuComponent.hide);
    };
    return TableContextMenu;
}());
exports.TableContextMenu = TableContextMenu;
//# sourceMappingURL=table-context-menu.js.map